<template>
  <template v-if="getShow">
    <LoginFormTitle class="enter-x" />
    <Form class="p-4 enter-x" :model="formData" :rules="getFormRules" ref="formRef">
      <ARow :gutter="16" class="enter-x">
        <ACol :span="12">
          <FormItem name="firstName" class="enter-x">
            <Input
              class="fix-auto-fill"
              size="large"
              v-model:value="formData.firstName"
              :placeholder="t('sys.login.firstNamePlaceholder')"
              @focus="handleFocus('firstName')"
            >
              <template #prefix>
                <SvgIcon name="user" size="18" />
              </template>
            </Input>
          </FormItem>
        </ACol>
        <ACol :span="12">
          <FormItem name="lastName" class="enter-x">
            <Input
              class="fix-auto-fill"
              size="large"
              v-model:value="formData.lastName"
              :placeholder="t('sys.login.lastNamePlaceholder')"
              @focus="handleFocus('lastName')"
            >
              <template #prefix>
                <SvgIcon name="user" size="18" />
              </template>
            </Input>
          </FormItem>
        </ACol>
      </ARow>
      <!-- <FormItem name="email" class="enter-x">
        <Input
          class="fix-auto-fill"
          size="large"
          v-model:value="formData.email"
          :placeholder="t('sys.login.emailPlaceholder')"
        >
          <template #prefix>
            <SvgIcon name="mail" size="18" />
          </template>
        </Input>
      </FormItem> -->
      <FormItem name="email" class="enter-x">
        <Input
          size="large"
          v-model:value="formData.email"
          :placeholder="t('sys.login.emailPlaceholder')"
          @focus="handleFocus('email')"
        >
          <template #prefix>
            <SvgIcon name="mail" size="18" />
          </template>
        </Input>
      </FormItem>

      <FormItem name="otp" class="enter-x">
        <Input
          size="large"
          v-model:value="formData.otp"
          :placeholder="t('sys.login.smsPlaceholder')"
          @focus="handleFocus('otp')"
        >
          <template #prefix>
            <SvgIcon name="lock-on" size="18" />
          </template>
          <template #suffix>
            <CountButton
              type="link"
              size="small"
              v-model:value="formData.otp"
              :placeholder="t('sys.login.smsCode')"
              :beforeStartFunc="handleSms"
              :disabled="!formData.email"
            />
          </template>
        </Input>
      </FormItem>
      <FormItem name="password" class="enter-x">
        <StrengthMeter
          size="large"
          v-model:value="formData.password"
          :placeholder="t('sys.login.password')"
          @focus="handleFocus('password')"
          :maxlength="20"
        >
          <template #prefix>
            <SvgIcon name="lock-on" size="18" />
          </template>
        </StrengthMeter>
      </FormItem>
      <FormItem name="confirmPassword" class="enter-x">
        <InputPassword
          size="large"
          visibilityToggle
          v-model:value="formData.confirmPassword"
          :placeholder="t('sys.login.confirmPassword')"
          @focus="handleFocus('confirmPassword')"
          :maxlength="20"
        >
          <template #prefix>
            <SvgIcon name="lock-on" size="18" />
          </template>
        </InputPassword>
      </FormItem>
      <Button
        type="primary"
        class="enter-x"
        size="large"
        block
        @click="handleRegister"
        :loading="loading"
      >
        {{ t('sys.login.registerButton') }}
      </Button>
      <section class="flex justify-center mt-6 enter-x">
        <span>{{ t('sys.login.haveAccount') }} </span>
        <a :class="prefixCls" @click="handleBackLogin">
          {{ t('sys.login.signInNow') }}
        </a>
      </section>
    </Form>
  </template>
</template>
<script lang="ts" setup>
  import { reactive, ref, unref, computed } from 'vue';
  import LoginFormTitle from './LoginFormTitle.vue';
  import { Form, Input, Button, Col, Row } from 'ant-design-vue';
  import { StrengthMeter } from '/@/components/StrengthMeter';
  import { useI18n } from '@mcex/locale';
  import { SvgIcon } from '/@/components/Icon';
  import { useLoginState, useFormRules, useFormValid, LoginStateEnum } from './useLogin';
  import { useDesign } from '/@/hooks/web/useDesign';
  import { SinUp, RegisterSendEmail } from '/@/api/sys/user';
  import { useMessage } from '/@/hooks/web/useMessage';
  import { CountButton } from '/@/components/CountDown';
  import Logan from '@mci-fe/logan-web';
  import { LogType } from '/@/enums/log';

  const ACol = Col;
  const ARow = Row;
  const FormItem = Form.Item;
  const InputPassword = Input.Password;
  const { t } = useI18n();
  const { handleBackLogin, getLoginState } = useLoginState();

  const formRef = ref();
  const loading = ref(false);
  const sendSms = ref(false);

  const formData = reactive({
    email: '',
    firstName: '',
    lastName: '',
    password: '',
    confirmPassword: '',
    policy: false,
    otp: '',
  });

  const { getFormRules } = useFormRules(formData);
  const { validForm, validateFields } = useFormValid(formRef);
  const { prefixCls } = useDesign('register-link');
  const { createMessage } = useMessage();

  const getShow = computed(() => unref(getLoginState) === LoginStateEnum.REGISTER);

  async function handleRegister(params) {
    const data = await validForm();
    if (!data) return;
    try {
      const verifyParams = {
        businessType: 'register',
        businessKey: formData.email,
        captchaVerification: params.captchaVerification,
      };
      const res = await SinUp({
        ...data,
        ...verifyParams,
      });
      console.log('🚀 ~ file: RegisterForm.vue:134 ~ handleRegister ~ res:', res);
      // 弹窗提示创建成功
      // createSuccessModal({
      //   title: t('sys.login.registerSuccessTitle'),
      //   content: t('sys.login.registerSuccessContent'),
      //   onOk: () => {
      //     handleBackLogin();
      //   },
      // });
      createMessage.success(t('sys.login.registerSuccessContent'), 1.5, () => {
        handleBackLogin();
      });
    } catch (e) {
      Logan.log(`handleRegister error: ${JSON.stringify(e)}`, LogType.Error);
    }
  }

  const handleSms = async () => {
    try {
      await validateFields(['email']);
    } catch (error) {
      createMessage.error(t('sys.login.smsSendFail'), 1.5);
      return false;
    }

    // TODO: 发送验证码
    try {
      const queryParams = {
        email: formData.email,
      };
      await RegisterSendEmail(queryParams);
      createMessage.success(t('sys.login.smsSended'), 1.5);
      sendSms.value = true;
      return true;
    } catch (error) {
      console.log('RegisterSendEmail', error);
      sendSms.value = false;
      return false;
    }
  };
  const handleFocus = (key: string) => {
    const _formRef = unref(formRef);
    _formRef?.clearValidate([key]);
    console.log('🚀 ~ file: RegisterForm.vue:134 ~ handleRegister ~ e:', key);
  };
</script>
<style lang="less" scoped>
  @prefix-cls: ~'@{namespace}-register-link';

  .@{prefix-cls} {
    color: @other-link-color;
  }
</style>
